// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FirmBaseFaq_wrapper__o76hS","qa_item":"FirmBaseFaq_qa_item__mhgsc","answer":"FirmBaseFaq_answer__yNhTP"};